/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState, start_hour, end_hour } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function OrderEdit(props) {
  const { login, onClose, seq } = props;
  const token = localStorage.getItem("token");
  const [name, setName] = useState("");
  const [sdate, setSdate] = useState(null);
  const [edate, setEdate] = useState(null);
  const [state, setState] = useState(null);

  const onSubmit = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/smartkey_edit",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
        sdate: sdate,
        edate: edate,
        state: state,
      }
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClose();
        }
      );
    }
  };

  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/smartkey_one",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq
      }
    );
    if (result.data.success === 1) {
      setState(result.data.row.state);
      setSdate(result.data.row.sdate);
      setEdate(result.data.row.edate);
      setName(result.data.row.mb_name);
      
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  const onDeleteClick = () => {
    Swal.fire({
      title: "삭제하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass_admin/smartkey_del",
            {
              token: token,
              cid: login.cid,
              level: login.level,
              mcd: login.mcd,
              seq: seq,
            }
          );
          if (result.data.success === 1) {
            onClose();
          } else {
            Swal.fire(result.data.msg);
          }
        }
      })
      .catch((e) => alert(e));
  };

  useEffect(() => {
    load_data();
  }, []);

  return (
    <Box>
      <Box
        css={css`
          padding: 20px 60px;
        `}
      >
        <Box sx={{ mt: 1 }}></Box>

        {/* 고객명 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="name"
            label="고객명"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={name}
          ></TextField>          
        </Box>

        <Box sx={{ mt: 1 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
            <DateTimePicker
              label="시작시간"
              value={sdate}
              onChange={(newValue) => {
                setSdate(moment(newValue).format("YYYY-MM-DD HH:mm:00"));
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Box>

        <Box sx={{ mt: 1 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
            <DateTimePicker
              label="종료시간"
              value={edate}
              onChange={(newValue) => {
                setEdate(moment(newValue).format("YYYY-MM-DD HH:mm:00"));
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Box>        

        {/* 상태 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <FormLabel>상태</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            name="state"
            onChange={(e) => setState(e.target.value)}
            value={state}
          >
            <FormControlLabel value="Y" control={<Radio />} label="Y" />
            <FormControlLabel value="" control={<Radio />} label="N" />
          </RadioGroup>
        </FormControl>        

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            수정완료
          </Button>

          <Button
            variant="contained"
            css={css`
              margin-left: 10px;
            `}
            onClick={onClose}
          >
            취소
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onDeleteClick}
          >
            삭제
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default OrderEdit;
